import React from 'react';

const FileField = ({field, form, id}) => {
    const handleChange = React.useCallback((e) => {
        form.setFieldValue(field.name, e.target.files[0]);
    }, [field.name, form]);
    return <input type="file" id={id} className="form-control-file" name={field.name} onChange={handleChange} />;
};

export default FileField;
